import FirstTimeQuestion from '@/common/containers/FirstTimeQuestion/FirstTimeQuestion';

export default FirstTimeQuestion;
